import AnalyticsGateway from 'lib/AnalyticsGateway';
import APM from 'lib/ApmRum';
import LaunchDarklyGateway from 'lib/LaunchDarklyGateway';
import { loadPreferences } from 'actionCreators/preferences';
import {locationInfo} from 'Routes';

const initializeAnalytics = (data, dispatch, getState) => {
    AnalyticsGateway.identifyUser(data);

    const {reportType: {value: reportTypeValue}, login: {timedout}} = getState();

    if (timedout) {
        const pathname = window.location.hash.substring(1);
        AnalyticsGateway.sendEvent({
            eventName: 'Successful ReLogin Signature',
            properties: [
                {label: 'Name', value: data.username},
                {label: 'Franchise', value: data.franchiseId},
                {label: 'Franchise Name', value: data.tradeName},
                {label: 'Site', value: 'Signature'},
                {label: 'Report Type', value: reportTypeValue},
                {label: 'Page Name', value: locationInfo(pathname).pageContext},
                {label: 'Resume Page', value: pathname},
                {label: 'TimeLastUsed', value: Math.floor((Date.now() - timedout) / 1000 / 60)},
            ],
        });
    }
};

const initializeLaunchDarkly = (data, dispatch) => {
    const ldPromise = LaunchDarklyGateway.updateUser(data) || Promise.resolve();
    ldPromise.then(() => dispatch(loadPreferences()));
};

const initializeApm = (data) => {
    APM.setUserContext({
        username: data.username,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.workEmail,
    });
};

export default {
    initializeApm,
    initializeAnalytics,
    initializeLaunchDarkly
};